var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-full"},[_c('div',{staticClass:"container__nav__revisao",staticStyle:{"display":"flex"}},[_c(_setup.Breadcrumb,{staticClass:"breadcrumb__internal",attrs:{"crumbs":_vm.crumbs,"value":_vm.value}}),_vm._t("actions")],2),_c('div',{staticClass:"relative h-full"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }